var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SkippedGoodsWarning.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-f06d0c92!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SkippedGoodsWarning.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SkippedGoodsWarning.vue
// module id = 87
// module chunks = 1